/**
 * ⭐ FAVORITOS DO MENU — o atalho no topo, SEM tirar o item do lugar dele.
 *
 * 🟥 22/09: fixar um item o removia do grupo de origem ("vive só no topo, sem duplicar").
 * Com a barra lateral rolada, o favorito fica fora da vista, e o dono procurou Orçamentos
 * em COMERCIAL, não achou, e concluiu que o módulo tinha sumido do sistema.
 *
 * Fixar é ganhar um atalho, não mudar a tela de lugar. O item passa a aparecer NOS DOIS:
 * no grupo "⭐ Favoritos" no topo e no grupo de origem, com a estrelinha acesa nos dois.
 *
 * Puro de propósito: é o que o teste lê (a tela só monta).
 */

export type GrupoDeMenu<T extends { to: string }> = [string, T[]];

export function comFavoritosNoTopo<T extends { to: string }>(
  grupos: Array<GrupoDeMenu<T>>,
  favoritos: Set<string>,
  favKey: string,
): Array<GrupoDeMenu<T>> {
  if (favoritos.size === 0) return grupos;
  // A ordem do topo é a mesma em que os itens aparecem no menu — não a ordem em que
  // foram fixados: o menu tem que ficar parado no lugar onde o olho já aprendeu.
  const favItens = grupos.flatMap(([, itens]) => itens).filter((it) => favoritos.has(it.to));
  if (favItens.length === 0) return grupos;
  return [[favKey, favItens], ...grupos];
}
